import storageAvailable from '../../../../helpers/storage_available';
import { StoredAddress } from './types';

// Function to get the stored session data
const getStoredAddress = (): string => {
  const defaultVal = JSON.stringify({ manual: false });
  if (!storageAvailable('sessionStorage')) {
    return defaultVal;
  }
  return sessionStorage.getItem('stored_address') || defaultVal;
};

// Function to set the stored session data
const setStoredAddress = (data: StoredAddress = { manual: false }): void => {
  if (!storageAvailable('sessionStorage')) {
    return;
  }
  sessionStorage.setItem('stored_address', JSON.stringify(data));
};

// Function to remove stored session data
const removeStoredAddress = (): void => {
  if (!storageAvailable('sessionStorage')) {
    return;
  }
  sessionStorage.removeItem('stored_address');
};

// Function to safely update an input value
const updateInputByName = (selector: string, value: string): void => {
  const input = document.querySelector<HTMLInputElement>(
    `input[name="${selector}"]`,
  );
  if (input) {
    input.value = value;
    input.dispatchEvent(new Event('change'));
  } else {
    console.log(`Can't update (${selector}). Does the element exist?`);
  }
};

// Function to safely get an input element
const getInputByName = (selector: string): HTMLInputElement | null => {
  return document.querySelector<HTMLInputElement>(`input[name="${selector}"]`);
};

// Function to get the postcode block
const getPostcodeBlock = (): Element | null => {
  return document.querySelector<HTMLElement>('.form_row_postcode');
};

// Function to get the manual entry block
const getManualEntryBlock = (): Element | null => {
  return document.querySelector<HTMLElement>('.address_manual_form');
};

// Function to validate a UK Postcode
const validatePostcode = (postcode: string): boolean => {
  return /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/.test(
    postcode,
  );
};

// Function to flag that this is a manual address
// by updating the hidden manual_address_entry input.
const setManualEntryInput = (value: string): void => {
  updateInputByName('manual_address_entry', value);
};

// Function to update the street_name input
const setStreetNameInput = (value: string): void => {
  updateInputByName('street_name', value);
};

export {
  getInputByName,
  getManualEntryBlock,
  getPostcodeBlock,
  getStoredAddress,
  removeStoredAddress,
  setManualEntryInput,
  setStoredAddress,
  setStreetNameInput,
  updateInputByName,
  validatePostcode,
};
